import { Box, Typography, alpha } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';

// Shown in place of a report list when the server refuses access (401/403)
export default function ReportsAccessNotice({ message }) {
  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        textAlign: 'center',
        borderRadius: '16px',
        bgcolor: alpha('#f4f6f8', 0.6),
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: 'auto',
          mb: 2,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          bgcolor: alpha('#ed6c02', 0.1),
          color: '#ed6c02',
        }}
      >
        <LockOutlined />
      </Box>
      <Typography variant="subtitle1" fontWeight={700}>
        You can't view these reports yet
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440, mx: 'auto', mt: 0.5 }}>
        {message ||
          "Your account doesn't have permission to view facility reports. Ask an administrator to give your role the View Report permission."}
      </Typography>
    </Box>
  );
}
